import {WS_CMD_RESPONSE, WS_CMDs, WS_DATA_TYPE_CMD} from './models'

export const CHAT_ERROR_TYPE = 'ERR'

export interface WS_DIRECT_MESSAGE_ERROR_DATA {
  type: 'ERR'
  data: {
    code: number | string
    key?: string
  }
  meta?: {
    event?: {
      type: 'CMD_R'
      data?: unknown
      meta: {
        id: string
        cmd: string
      }
    }
  }
}

/*
 TODO: Split into two separate interfaces. Some properties are only used when sending messages, while others are relevant only when receiving messages. Separating these concerns will improve type safety, code readability, and help prevent misuse of fields that are not applicable in a given context.
*/
export interface WS_ASSISTANT_METADATA {
  demandId?: string
  topic?: string
  questionType?: string
  sessionCompleted?: boolean
  action?: string
  summary?: string
  serviceId?: string
  buttonLabel?: string
  attachment?: string
  eventDate?: number
  location?: {
    regions: string[]
    offices: string[]
    address: string
    lat: number
    lon: number
    range?: number
  }
}

// DIRECT MESSAGES
export const DIRECT_MESSAGE_TYPE = 'DDM'

export interface WS_DIRECT_MESSAGE_RECEIVE_DATA {
  type: 'DDM'
  data: {
    _id: string
    senderId: string
    text: string
    /**
     * Possible duplication of text prop due dontsearch app lib mistake
     */
    body: string
    ts: number
    metadata?: WS_ASSISTANT_METADATA
    code?: number | string
    key?: string
  }
  meta: {
    assignment: {
      _id: string
    }
    sender: {
      id: string
      name: string
    }
  }
}

export interface WS_DIRECT_MESSAGE_SEND_DATA {
  type: 'DDM'
  data: {
    _id: string
    text: string
    metadata?: WS_ASSISTANT_METADATA
  }
  meta: {
    assignment: {
      _id: string
    }
    recipient: {
      id: string
    }
  }
}

// HISTORY MESSAGES
export const DIRECT_MESSAGE_HISTORY_TYPE = 'DDM_H'

export interface WS_DIRECT_MESSAGE_HISTORY_MESSAGE {
  _id: string
  senderId: string
  text: string
  ts: number // timestamp
  metadata?: WS_ASSISTANT_METADATA
}

export interface WS_DIRECT_MESSAGE_HISTORY_DATA {
  type: 'DDM_H'
  data: {
    id: string
    recipient: {
      id: string
      name: string
      online: boolean
    }
    messages: WS_DIRECT_MESSAGE_HISTORY_MESSAGE[]
  }
  meta: {
    event: {
      type: WS_CMD_RESPONSE
      meta: {
        id: string
        cmd: string
      }
    }
  }
}

// CONVERSATIONS
export const ACTICE_CONVERSATION_TYPE = 'CNVS'

export interface WS_ACTIVE_CONVERSATION_DATA {
  type: 'CNVS'
  data: {
    chats: {
      id: string
      unseen: number
      recipient: {
        id: string
        name: string
        online: boolean
      }
    }[]
  }
  meta: {
    event: {
      type: WS_CMD_RESPONSE
      meta: {
        id: string
        cmd: WS_CMDs
      }
    }
  }
}

// SEEN MESSAGES COMMAND
export const DIRECT_MESSAGE_SEEN_TYPE = 'DDM_S'

export interface WS_CND_DIRECT_MESSAGE_SEEN_DATA {
  type: 'DDM_S'
  data: {
    _id: string
    chatId: string
    seen: boolean
  }
}

// UNSEEN+ACTION COMMAND
export interface WS_CMD_ACTIVE_COMMAND {
  type: WS_DATA_TYPE_CMD
  data: {
    id: string
    cmd: WS_CMDs
  }
}

// DELETE CHAT COMMAND
export const DELETE_CHAT_TYPE = 'DDM_D'

export interface WS_DELETE_CHAT_DATA {
  type: 'DDM_D'
  data: {
    chatId: string
  }
  meta: {
    event: {
      type: WS_CMD_RESPONSE
      meta: {
        id: string
        cmd: WS_CMDs
      }
    }
  }
}
